import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';
import { connect } from 'react-redux';
import FilterFlowNavigation from '../filterFlowNavigation/filterFlowNavigation';
import { activeFilterStepPropType, filtersPropType } from '../../utils/propTypes';
import { baseRoutes, filterStepsTypes } from '../../appSettings';
import './footer.scss';

const Footer = ({
  activeFilterStep,
  filters,
  totalHits,
  labels,
}) => {
  const [inFilterFlow, setInFilterFlow] = useState(false);
  const [hasBackgroundImage, setHasBackgroundImage] = useState(false);
  const location = useLocation();

  useEffect(()=> {
    setInFilterFlow(location.pathname !== `/${baseRoutes.START}` && location.pathname !== `/${baseRoutes.CONGRATULATIONS}`);
    setHasBackgroundImage(location.pathname === `/${filterStepsTypes.DESTINATION_TRAITS_SELECTION}` ||
      location.pathname === `/${filterStepsTypes.DESTINATION_TRAITS_DETAILS}`);
  }, [location.pathname]);

  const footerClasses = classnames({
    'vf-footer': true,
    'vf-footer-hidden': !inFilterFlow,
  });

  return (
    <footer className={footerClasses}>

      { inFilterFlow && (
        <>
          {!hasBackgroundImage && <div className='vf-footer__fade' />}
          <FilterFlowNavigation
            activeFilterStep={activeFilterStep}
            labels={labels}
            filters={filters} 
            totalHits={totalHits} />
        </>
      )}
    </footer>
  )
}

Footer.propTypes = {
  labels: PropTypes.shape({
    filterFooterNext: PropTypes.string.isRequired,
    filterFooterSeeResults1: PropTypes.string.isRequired,
    filterFooterSeeResults2: PropTypes.string.isRequired,
    resultListUrl: PropTypes.string.isRequired,
    filterFlowNavNoHits: PropTypes.string.isRequired,
  }).isRequired,
  filters: PropTypes.shape(filtersPropType).isRequired,
  activeFilterStep: PropTypes.shape(activeFilterStepPropType).isRequired,
  totalHits: PropTypes.number,
};

Footer.defaultProps = {
  totalHits: null,
};


const mapStateToProps = ({ siteSettings, results, attributeCollection }) => {
  const labels = {
    filterFooterNext: attributeCollection.filterFooterNext,
    filterFooterSeeResults1: attributeCollection.filterFooterSeeResults1,
    filterFooterSeeResults2: attributeCollection.filterFooterSeeResults2,
    resultListUrl: attributeCollection.resultListUrl,
    filterFlowNavNoHits: attributeCollection.filterFlowNavNoHits,
  };

  return {
    labels,
    filters: siteSettings.filters,
    activeFilterStep: siteSettings.activeFilterStep,
    totalHits: results.resultsCount.total,
    
  };
};

export default connect(mapStateToProps)(Footer);